import React, { Component } from "react";
import { Card, OverlayTrigger, Tooltip } from "react-bootstrap";

class Panel extends Component {
  constructor(props) {
    super(props);
  }

  renderTooltip(props, tooltip) {
    return (
      tooltip ?
        <Tooltip id="button-tooltip" {...props}> {tooltip} </Tooltip>
        : <div></div>
    );
  }

  render() {
    const { title, children, style, tooltip, tooltipPlacement, hiddenBody } = this.props;

    return (
      <fieldset>
        <OverlayTrigger
          placement={tooltipPlacement || "top"}
          delay={{ show: 250, hide: 400 }}
          overlay={props => this.renderTooltip(props, tooltip)}
        >

          <Card className="panel panel-default" style={style}>
            {title && (
              <Card.Header className="panel-heading">
                <h3 className="panel-title">{title}</h3>
              </Card.Header>
            )}
            {!hiddenBody && <Card.Body>{children}</Card.Body>}
          </Card>
        </OverlayTrigger>
      </fieldset>

    );
  }
}

export default Panel;
